/* Hungry Herd Theme JS */

document.addEventListener('DOMContentLoaded', function () {

// ---- Scroll animations ----
const animatedElements = document.querySelectorAll('[data-animation]');

if (animatedElements.length > 0) {
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const delay = entry.target.dataset.delay || 0;
        entry.target.style.transitionDelay = delay + 'ms';
        entry.target.classList.add('animated');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15
  });

  animatedElements.forEach(function (el) {
    observer.observe(el);
  });
}

  // ---- Mobile menu ----
  const toggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', mobileMenu.classList.contains('open'));
    });
  }

// ---- Quantity controls ----
document.querySelectorAll('.pdp-qty-control').forEach(function (ctrl) {
  const minus = ctrl.querySelector('.qty-btn-minus');
  const plus = ctrl.querySelector('.qty-btn-plus');
  const val = ctrl.querySelector('.qty-value');
  const input = ctrl.closest('form') ? ctrl.closest('form').querySelector('.qty-input') : null;
  const max = parseInt(ctrl.dataset.max, 10) || 99;

  if (!minus || !plus || !val) return;

  function updateButtons(current) {
    if (current >= max) {
      plus.classList.add('qty-btn-disabled');
      plus.disabled = true;
    } else {
      plus.classList.remove('qty-btn-disabled');
      plus.disabled = false;
    }
    if (current <= 1) {
      minus.classList.add('qty-btn-disabled');
      minus.disabled = true;
    } else {
      minus.classList.remove('qty-btn-disabled');
      minus.disabled = false;
    }
  }

  minus.addEventListener('click', function () {
    const current = parseInt(val.textContent, 10);
    if (current > 1) {
      val.textContent = current - 1;
      if (input) input.value = current - 1;
      updateButtons(current - 1);
    }
  });

  plus.addEventListener('click', function () {
    const current = parseInt(val.textContent, 10);
    if (current < max) {
      val.textContent = current + 1;
      if (input) input.value = current + 1;
      updateButtons(current + 1);
    }
  });

  // Set initial state
  updateButtons(parseInt(val.textContent, 10));
});

  // ---- Hero dot navigation ----
  const heroSlides = document.querySelectorAll('.hero-slide');
  const heroDots = document.querySelectorAll('.hero-dot');
  let currentSlide = 0;

  function goToSlide(index) {
    heroSlides.forEach(function (s, i) {
      s.style.opacity = i === index ? '1' : '0';
    });
    heroDots.forEach(function (d, i) {
      d.classList.toggle('active', i === index);
    });
    currentSlide = index;
  }

  heroDots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goToSlide(i); });
  });

  // Auto-advance if multiple slides
  if (heroSlides.length > 1) {
    setInterval(function () {
      goToSlide((currentSlide + 1) % heroSlides.length);
    }, 5000);
  }

  // ---- PDP thumbnail gallery ----
  const thumbnails = document.querySelectorAll('.pdp-thumbnail');
  const mainImage = document.querySelector('.pdp-gallery-main img');

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbnails.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.src = thumb.dataset.src;
      }
    });
  });

  // ---- Sticky promo sidebar ----
  // Already handled via CSS fixed positioning

  // ---- Cart remove items ----
  document.querySelectorAll('.cart-remove-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.cart-item');
      if (item) {
        item.style.opacity = '0';
        item.style.transition = 'opacity 0.3s ease';
        setTimeout(function () { item.remove(); }, 300);
      }
    });
  });

  // ---- Add to cart feedback ----
  document.querySelectorAll('.add-to-cart-btn, .pdp-add-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      const original = btn.textContent;
      btn.textContent = 'Added!';
      btn.style.background = '#2d6a4f';
      setTimeout(function () {
        btn.textContent = original;
        btn.style.background = '';
      }, 1500);
    });
  });

  // ---- Email form ----
  const emailForm = document.querySelector('.email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = emailForm.querySelector('input');
      const btn = emailForm.querySelector('button');
      if (input && input.value) {
        btn.textContent = 'Subscribed!';
        input.value = '';
        setTimeout(function () { btn.textContent = 'Join Now'; }, 2000);
      }
    });
  }

});


// Fade Appstle widget near bottom of page
window.addEventListener('scroll', function () {
  const widget = document.getElementById('appstle-loyalty-button');
  if (!widget) return;

  const scrolledToBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight * 0.95);
  widget.style.opacity = scrolledToBottom ? '0' : '1';
  widget.style.pointerEvents = scrolledToBottom ? 'none' : 'auto';
});

// Add shadow to header on scroll
const siteHeader = document.querySelector('#shopify-section-header');
if (siteHeader) {
  window.addEventListener('scroll', function () {
    if (window.scrollY > 10) {
      siteHeader.classList.add('header-scrolled');
    } else {
      siteHeader.classList.remove('header-scrolled');
    }
  });
}